import React from 'react';
import { styled } from '@mui/material/styles';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../Constants';
import Flag from 'react-world-flags';
import { ArrowDropDownCircle } from '@mui/icons-material';
import { PSEUDO_LANGUAGE, isPseudoAvailable } from 'src/i18n/language';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// Language names are each language's own name for itself: never translated.
// The pseudo-locale (TGCLOUD-1893) is offered outside production builds only:
// in it, any text still plain English never went through t().
const menuLanguages = () =>
  isPseudoAvailable()
    ? [
        ...CONSTANTS.languages,
        { value: PSEUDO_LANGUAGE, label: 'Pseudo (translation check)' }
      ]
    : CONSTANTS.languages;

const CustomSelect = styled('div')({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'center',
  gap: 6,
  right: 5
});

const StyledSelect = styled(Select)({
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  }
});

const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  alignItems: 'center',
  gap: 10
});

function TranslationMenu({ color }) {
  const t = useAutoTranslation();

  const options = menuLanguages();

  const selectRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const onSelect = () => {
    setOpen(true);
    selectRef.current.focus();
  };

  const { i18n } = useTranslation();

  const handleChange = (e) => {
    localStorage.setItem('lang', e.target.value);
    i18n.changeLanguage(e.target.value);
  };

  return (
    <Grid>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          position: 'relative'
        }}
      >
        {color && (
          <CustomSelect
            data-va-anchor="topbar.language"
            aria-label={t('Choose language')}
            onClick={onSelect}
          >
            <Flag
              code={CONSTANTS.flags[i18n.language]}
              height={28}
              width={28}
              style={{ borderRadius: 5 }}
            />
            <ArrowDropDownCircle style={{ fontSize: 13 }} />
          </CustomSelect>
        )}

        <FormControl fullWidth style={color && { opacity: 0 }}>
          <StyledSelect
            ref={selectRef}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            fullWidth
            // className={classes.select}
            style={{
              color: color,
              paddingRight: color ? 0 : 20
            }}
            variant={'outlined'}
            value={i18n.language}
            onChange={handleChange}
          >
            {options.map((option) => {
              return (
                <StyledMenuItem key={option.value} value={option.value}>
                  <Flag
                    code={CONSTANTS.flags[option.value]}
                    height={35}
                    width={35}
                    style={{ borderRadius: 10 }}
                  />
                  {option.label}
                </StyledMenuItem>
              );
            })}
          </StyledSelect>
        </FormControl>
      </div>
    </Grid>
  );
}

export default TranslationMenu;
